// this simply returns a unique key to distinguish requests according to filters

const getCacheKey = (
    packCode: string,
    startDate: string | null,
    endDate: string | null,
    season: string,
    participants: number[],
    skipass?: number | null
): string => {
    const parts = [
        packCode,
        startDate ?? "",
        endDate ?? "",
        season,
        participants.join(",")
      ]
      if (skipass != null) {
        parts.push(`skipass${skipass}`)
      }
      return parts.join(" - ")
}

export default getCacheKey

